import React from 'react';

const ReturnFlightTabs = ({ activeTab, onTabChange, searchData, departureAirport, arrivalAirport }) => {
  const fromDisplay = departureAirport ? `${departureAirport.iata}` : searchData.from;
  const toDisplay = arrivalAirport ? `${arrivalAirport.iata}` : searchData.to;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });
    const day = date.getDate();
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const year = date.getFullYear().toString().slice(-2);
    return `${weekday} ${day} ${month} ${year}`;
  };

  return (
    <div className="mb-4">
      <div className="flex gap-0">
        {/* Outbound Tab */}
        <button
          onClick={() => onTabChange('outbound')}
          className={`flex-1 px-6 py-4 text-center transition-colors border-0 ${activeTab === 'outbound'
              ? 'bg-[#ffd200] text-black'
              : 'bg-[#e6e6e6] text-black hover:bg-[#d9d9d9]'
            }`}
          style={{ minHeight: '70px' }}
        >
          <div className="font-bold text-base">
            {fromDisplay} → {toDisplay}
          </div>
          <div className="text-sm font-bold mt-1">
            {formatDate(searchData.departure)}
          </div>
        </button>

        {/* Return Tab */}
        <button
          onClick={() => onTabChange('return')}
          className={`flex-1 px-6 py-4 text-center transition-colors border-0 ${activeTab === 'return'
              ? 'bg-[#ffd200] text-black'
              : 'bg-[#e6e6e6] text-black hover:bg-[#d9d9d9]'
            }`}
          style={{ minHeight: '70px' }}
        >
          <div className="font-bold text-base">
            {toDisplay} → {fromDisplay}
          </div>
          <div className="text-sm font-bold mt-1">
            {searchData.return}
          </div>
        </button>
      </div>
    </div>
  );
};

export default ReturnFlightTabs;
